import React from 'react';

import PropTypes from 'prop-types';

import {
    ContentSection,
    Content,
    MarkdownContent,
    Sidebar,
    Statistic,
    Typography,
} from 'wanderu-components';

import CarrierStatsTable from '../../CarrierStatsTable/CarrierStatsTable';
import StatisticsContainer from '../../StatisticsContainer/StatisticsContainer';
import CarrierDescription from '../CarrierDescription/CarrierDescription';

import styles from './TravelStats.scss';

function TravelStats(props) {
    const {
        bottomStat,
        bottomStatTitle,
        bottomStatUnits,
        carrierData,
        className,
        description,
        layoutClassName,
        namespace,
        sectionTitle,
        statType,
        topStat,
        topStatTitle,
        topStatUnits,
    } = props;

    return (
        <ContentSection
            className={className}
            id={`c2c-travel-${statType}`}
            layoutClassName={layoutClassName}
            title={(
                <Typography
                    component="h3"
                    variant="h6"
                >
                    {sectionTitle}
                </Typography>
            )}
            isCollapsable
            useAccordionComponent
        >
            <Content>
                <MarkdownContent>
                    {description}
                </MarkdownContent>
            </Content>
            {!!carrierData.length && (
                <>
                    <CarrierStatsTable
                        carrierData={carrierData}
                        namespace={namespace}
                    />
                    <CarrierDescription carrierData={carrierData} />
                </>
            )}
            {bottomStat !== topStat && (
                <Sidebar className={styles.sidebar}>
                    <StatisticsContainer>
                        <Statistic
                            title={topStatTitle}
                            units={topStatUnits}
                            value={topStat}
                        />
                        <Statistic
                            title={bottomStatTitle}
                            units={bottomStatUnits}
                            value={bottomStat}
                        />
                    </StatisticsContainer>
                </Sidebar>
            )}
        </ContentSection>
    );
}

TravelStats.propTypes = {
    bottomStat: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    bottomStatTitle: PropTypes.string,
    bottomStatUnits: PropTypes.string,
    carrierData: PropTypes.arrayOf(PropTypes.shape({
        [PropTypes.string]: PropTypes.shape({
            carrierCode: PropTypes.string,
            features: PropTypes.arrayOf(PropTypes.number),
            liveDetails: PropTypes.bool,
            maxSeats: PropTypes.number,
            name: PropTypes.string,
            preferredCurrency: PropTypes.string,
            supplementalInfo: PropTypes.shape({
                serviceAttribution: PropTypes.objectOf(PropTypes.string),
                tripInfo: PropTypes.shape({
                    locale: PropTypes.string,
                    selectedFares: PropTypes.arrayOf(PropTypes.string),
                    tripIds: PropTypes.arrayOf(PropTypes.string),
                }),
            }),
            ticketDelivery: PropTypes.shape({
                eTicket: PropTypes.bool,
                idRequired: PropTypes.bool,
            }),
            vehicleType: PropTypes.string,
        }),
    })),
    className: PropTypes.string,
    description: PropTypes.string.isRequired,
    layoutClassName: PropTypes.string,
    namespace: PropTypes.string,
    sectionTitle: PropTypes.string.isRequired,
    statType: PropTypes.string.isRequired,
    topStat: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    topStatTitle: PropTypes.string,
    topStatUnits: PropTypes.string,
};

TravelStats.defaultProps = {
    bottomStat: '',
    bottomStatTitle: '',
    bottomStatUnits: '',
    carrierData: [],
    className: '',
    layoutClassName: '',
    namespace: '',
    topStat: '',
    topStatTitle: '',
    topStatUnits: '',
};

export default TravelStats;
